module.exports = __webpack_public_path__ + "img/1.a14100d4.jpg";